import { Grid, Typography } from '@mui/material';
import { SimpleShowLayout, useRecordContext } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { FileDetails } from 'src/lib';
import { Account } from 'src/models';

import { AccountDetails } from './AccountDetails';
import { EntityInformation } from './EntityInformation';

export const AccountInformationShow = () => {
  const record = useRecordContext<Account>();

  return (
    <Grid container direction='row'>
      <AccountDetails />
      {record.type.isEntity && record.entityInformation && <EntityInformation />}
      {!record.type.isEntity && record.accountId && (
        <>
          <Grid item md={12}>
            <SimpleShowLayout>
              <Typography variant='h5'>Account Agreement</Typography>
            </SimpleShowLayout>
          </Grid>
          <FileDetails
            id='some-id'
            name={`${record.accountId}-account-agreement.pdf`}
            resource={{
              name: DataProviderResource.AccountAgreements,
              params: {
                id: record.id,
                meta: { name: `${record.accountId}-account-agreement.pdf`, type: 'pdf' },
              },
            }}
          />
        </>
      )}
    </Grid>
  );
};
